'use client'
import React, { FC } from 'react'
import CollectionIcon from '@/components/collection-icon'

const RuneTransferCard: FC<{
	collection: any
	ticker: string
	description: string
	children?: React.ReactNode
	onRemove: (e: any) => void
}> = (props) => {
	const { collection, ticker, description, onRemove: _onRemove } = props

	return (
		<div className="bg-background p-4 w-full rounded flex gap-4 flex-col">
			<div className="flex items-center gap-2">
				<CollectionIcon
					imageClassName="h-[38px] w-[38px] min-w-[38px] rounded-full"
					className="size-[38px] min-w-[38px] rounded-full overflow-hidden"
					collection={collection}
				/>
				<div className="flex flex-col">
					<p className="text-xs semibold">{ticker}</p>
					<p className="text-xs text-zinc-500 flex items-center gap-1">{description}</p>
				</div>
				<div className="grow" />
				{/* <RemoveIcon
					onClick={onRemove}
					className="cursor-pointer size-6 stroke-muted-foreground hover:stroke-foreground"
				/> */}
			</div>
			{props.children}
		</div>
	)
}

export default RuneTransferCard
